<template>
	<div class="user_div">
		<div class="step1_div">
			<el-form ref="form" :model="form1" label-width="80px">
				<el-form-item label="用户账号">
					<el-input v-model="form1.account"></el-input>
				</el-form-item>
				<el-form-item label="用户名称">
					<el-input v-model="form1.name"></el-input>
				</el-form-item>
				<el-form-item label="用户密码">
					<el-input show-password v-model="form1.password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码">
					<el-input show-password v-model="form1.password2"></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 2.5rem">
					<el-button type="primary" @click="onSubmit" style="width: 6.25rem;height: 2.8125rem;margin-right: 1.25rem;">保存</el-button>
					<el-button style="width: 6.25rem;height: 2.8125rem;" @click="back">取消</el-button>
				</el-form-item>
			</el-form>
		</div>

	</div>

</template>

<script>
	export default {
		name: 'adduser',
		data() {
			return {
				form1: {
					account: '',
					name: '',
					password: '',
					password2: ''
				},

			}
		},

		methods: {
			onSubmit() {
				console.log('adduser onSubmit')
				if (this.form1.account.length === 0) {
					this.$message({
						message: '请输入用户账号',
						type: 'warning'
					});
					return
				}
				if (this.form1.name.length === 0) {
					this.$message({
						message: '请输入用户名称',
						type: 'warning'
					});
					return
				}
				if (this.form1.password.length === 0) {
					this.$message({
						message: '请输入用户密码',
						type: 'warning'
					});
					return
				}
				if (this.form1.password2.length === 0) {
					this.$message({
						message: '请确认密码不能为空',
						type: 'warning'
					});
					return
				}
				if (this.form1.password !== this.form1.password2) {
					this.$message({
						message: '请确认两次密码一致',
						type: 'warning'
					});
					return
				}

				this.$emit('addUser', this.form1)
			},

			back() {
				console.log('adduser userBack')
				this.$emit('userBack')
			}
		}
	}
</script>

<style scoped="scoped">
	.user_div {}

	.step1_div {
		width: 50%;
		margin: 0 auto;
		margin-top: 3.125rem;
	}
</style>
